import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import { connect } from 'react-redux'
import { recoverPassword } from 'reducers/user/userActions'

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      email: "",
      emailError: null
    };
  }

  componentWillMount() {
  }

  componentDidMount() {
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value
    });  
  }

  validateEmailError(value) {
    if (value.length == 0) {
      this.setState({
        emailError: (
          <small className="text-danger">
            El email es requerido
            </small>
        )
      });
      return false;
    }

    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value) === false) {
      this.setState({
        emailError: (
          <small className="text-danger">
            Ingrese el formato 'ejemplo@gmail.com' correo electrónico.
            </small>
        )
      });
      return false;
    }
    this.setState({ emailError: null });
    return true;
  }

  handleRecoverPassword() {
    if (this.validateEmailError(this.state.email)) {
      this.props.recoverPassword(this.state.email);
    }
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Recuperar Contraseña"
                content={
                  <div>
                    <FormGroup>
                      <ControlLabel>Correo electrónico</ControlLabel>
                      <FormControl
                        placeholder="Ingresa correo electrónico"
                        name="email"
                        type="email"
                        value={this.state.email}
                        onChange={event => this.handleEmailChange(event)}
                      />
                      {this.state.emailError}
                    </FormGroup>
                  </div>
                }
                legend={
                  <Button
                    bsStyle="info"
                    fill
                    wd
                    onClick={this.handleRecoverPassword.bind(this)}
                  >
                    Enviar correo electrónico
                  </Button>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect(null, { recoverPassword })(ForgotPasswordPage);


// WEBPACK FOOTER //
// ./src/views/Pages/ForgotPasswordPage.jsx